import { render } from "./addon-card.vue?vue&type=template&id=5211340e&scoped=true&ts=true"
import script from "./addon-card.vue?vue&type=script&lang=ts"
export * from "./addon-card.vue?vue&type=script&lang=ts"

import "./addon-card.vue?vue&type=style&index=0&id=5211340e&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5211340e"]])

export default __exports__